import { useContext } from 'react';

import { Context as ToastContext } from '../ToastContext/ToastContext';

type ToastMessageHandler = (...args: any[]) => void;

export function useToastMessage() {
  const { showMessage: showToastMessage, hideMessage: hideToastMessage } =
    useContext<{
      showMessage: ToastMessageHandler;
      hideMessage: ToastMessageHandler;
    }>(ToastContext);
  return { showToastMessage, hideToastMessage };
}
